<template>
  <AppButtonOk @click="$emit('click')">
    リンク取得<v-icon>link</v-icon>
  </AppButtonOk>
</template>

<script>
export default {
  name: 'SimulationFooterEditButtonGetLink',
}
</script>

<style scoped></style>
